import axios from '@/utils/axios'
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        creditNote: null,
        creditNotes: [],
    },
    mutations: {
        setCreditNote(state, payload) {
            state.creditNote = payload;
        },
        setCreditNotes(state, payload) {
            state.creditNotes = payload;
        }
    }, 
    actions: {
        storeCreditNote({rootState, dispatch}, payload) {
            const headers = {
                Authorization: `Bearer ${rootState.authentication.token}`,
                Dpk: payload.dpk
            }
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url:`${rootState.sales.routePrefix}/credit-notes`,
                    data: payload,
                    headers: headers
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        updateCreditNote({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `${rootState.sales.routePrefix}/credit-notes/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removeCreditNote({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.sales.routePrefix}/credit-notes/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removeCreditNotes({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.sales.routePrefix}/credit-notes`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        fetchCreditNote({ commit, rootState, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.sales.routePrefix}/credit-notes/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setCreditNote', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                } 
                );
            })
        },
        fetchCreditNotes({ commit, rootState, dispatch }, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.sales.routePrefix}/credit-notes?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setCreditNotes', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                }
                );
            })
        }

    }
}